export const useClarity = () => {
  const {
    public: { clarityId },
  } = useRuntimeConfig()

  return useScriptClarity({
    id: clarityId,
  })
}
